import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { ConnectFlowSurveyModel, Permission } from '@/types';
import { AnnotationIcon } from '@heroicons/vue/solid';
import { CheckCircleIcon, XCircleIcon, PencilAltIcon } from '@heroicons/vue/outline';
import UiAuditInfo from '@/components/UiAuditInfo.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectFlowSurveyListItem',
  props: {
    modelValue: {
        type: Object as PropType<ConnectFlowSurveyModel>,
        required: true,
    },
},
  emits: ['activate', 'inactivate'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const handleActivateClick = () => emit('activate', props.modelValue);
const handleInactivateClick = () => emit('inactivate', props.modelValue);

const __returned__ = { props, emit, handleActivateClick, handleInactivateClick, get Permission() { return Permission }, get AnnotationIcon() { return AnnotationIcon }, get CheckCircleIcon() { return CheckCircleIcon }, get XCircleIcon() { return XCircleIcon }, get PencilAltIcon() { return PencilAltIcon }, UiAuditInfo }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})